<template>
    <slide-x-left-transition :duration="400+(index*100)" :delay="200+(index*100)">
        <ion-item v-show="show" mode="ios" class="ion-activatable" @click="goTo(route, slug)" :disabled="disabled">
            <ion-label mode="md" class="ion-text-wrap">
                <h3>{{ title }}</h3>
                <svg class="icon icon-chevron-right" style="position: absolute; bottom: 8px; right: -2px; opacity: 0.5">
                    <use xlink:href="#icon-chevron-right"></use>
                </svg>
            </ion-label>
        </ion-item>
    </slide-x-left-transition>
</template>

<script>
    import goTo from '@/mixins/goto';

    export default {
        name: 'ItemMenu',
        mixins: [goTo],
        props: ['index','route','icon','content','slug','title','disabled'],
        data() {
            return {
                show: false
            }
        },
        mounted() {
            this.show = true;
        },
    }
</script>
